import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
// import { config } from "./config/firebase";
// import firebase from "firebase";
// import "firebase/app";
// import "firebase/auth";
import axios from "axios";
// Plugins
import App from "./App.vue";
import Chartist from "chartist";

import VeeValidate from "vee-validate";

import store from "./store";
// router setup
import router from "./routes/routes";
import { firebaseApp } from "./firebase/init";
// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VeeValidate);

Vue.prototype.$http = axios;
// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  created() {
    // eslint-disable-next-line
    new ClipboardJS(".clipboard");
    firebaseApp.auth().onAuthStateChanged(user => {
      console.warn("user from onAuthStateChanged");
      console.warn(user);

      if (user && user.email.slice(-7) === "@una.cl") {
        store.dispatch("users/google", user).then(res => {
          this.$router.push("/");
        });

        axios.defaults.headers.common["Authorization"] = user.email;
        // this.$router.push("/");
      } else {
        firebaseApp.auth().signOut();
        this.$router.push("/login");
      }
    });
  },
  data: {
    Chartist: Chartist
  }
});
